import type { PageContextTimeRange } from './types';

const browserTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone || 'UTC';

export const createPageContextTimeRange = (
  presetId: string | undefined,
  from: string,
  to: string,
): PageContextTimeRange => ({
  from,
  to,
  timeZone: browserTimeZone,
  ...(presetId ? { presetId } : {}),
});
